import { FaceTempleteService } from "@/api/service-proxies";

export const faceTempleteService = new FaceTempleteService();
